/**
 * Webversion vist under Info i topmenuen.
 * Hæv datoen eller løbenummeret før deploy, når I skal kunne se at appen har hentet et nyt web-build.
 */
export const webVersion = "2026-10-30 - 1.3.0";
